import { ButtonLink } from "../components/ButtonLink";

export function NotFoundPage() {
  return (
    <section className="not-found wrap">
      <p className="not-found__code display" aria-hidden="true">404</p>
      <p className="index-label"><span className="index-label__number">Lost</span><span>That page drifted away</span></p>
      <h1 className="display">We couldn’t find it in this tank.</h1>
      <p className="not-found__lede">Try the care guides or head back to the Aquarium Helpline home page.</p>
      <div className="not-found__actions">
        <ButtonLink href="/articles/">Browse care guides</ButtonLink>
        <ButtonLink href="/" variant="secondary">Back home</ButtonLink>
      </div>
    </section>
  );
}
